import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Feed from "./pages/Feed";
import Direct from "./pages/Direct";
import Chat1 from "./pages/Chat1";
import Chat2 from "./pages/Chat2";
import Chat3 from "./pages/Chat3";
import Chat4 from "./pages/Chat4";
import Chat5 from "./pages/Chat5";
import Cta from "./pages/Cta";
import Busca from "./pages/Busca";
import UpsellFirewall from "./pages/UpsellFirewall";
import Planos from "./pages/Planos";
import TrialGuard from "./components/TrialComponents/TrialGuard";
import { trackUtm } from "./utils/tracking";
import { saveUtmsFromUrl } from "./utils/utm";
import "./index.css";

// Login, registro, dashboard e créditos vivem no projeto ../backend-wp (pasta dashboard/).

function UtmTracker() {
  useEffect(() => {
    // Guarda as UTMs da chegada (anúncio) para sobreviverem a refresh, retorno e redirects
    saveUtmsFromUrl();
    // Rastrear UTM apenas uma vez quando o app carrega
    trackUtm().catch(err => console.warn('[App] Erro ao rastrear UTM:', err));
  }, []);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <UtmTracker />
      <Routes>
        {/* HOME SEM BLOQUEIO */}
        <Route path="/" element={<Home />} />

        {/* ROTAS PROTEGIDAS PELO TRIAL */}
        <Route path="/feed" element={<TrialGuard><Feed /></TrialGuard>} />
        <Route path="/direct" element={<TrialGuard><Direct /></TrialGuard>} />
        <Route path="/chat1" element={<TrialGuard><Chat1 /></TrialGuard>} />
        <Route path="/chat2" element={<TrialGuard><Chat2 /></TrialGuard>} />
        <Route path="/chat3" element={<TrialGuard><Chat3 /></TrialGuard>} />
        <Route path="/chat4" element={<TrialGuard><Chat4 /></TrialGuard>} />
        <Route path="/chat5" element={<TrialGuard><Chat5 /></TrialGuard>} />

        {/* CTA SEM BLOQUEIO (DESTINO FINAL) */}
        <Route path="/cta" element={<Cta />} />

        {/* PÓS-CHECKOUT / UPSELL E PLANOS - PÚBLICAS */}
        <Route path="/obrigado" element={<UpsellFirewall />} />
        <Route path="/upsell" element={<UpsellFirewall />} />
        <Route path="/planos" element={<Planos />} />
        <Route path="/plans-sell" element={<Planos />} />

        {/* LANDING ALTERNATIVA */}
        <Route path="/busca" element={<Busca />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
